import authType from '../../../config/authType';

const filterItems = [
  { label: '菜单名称', model: 'menuName', type: 'input', span: 6 },
  {
    type: 'button',
    span: 6,
    buttonArr: [
      { message: '查询', type: 'primary', fun: 'searchTableInfo' },
      { message: '重置', type: 'warning', fun: 'resetTableInfo' }
    ]
  }
];

const getColumnsMap = ({ editBtnClick, deleteBtnClick, pageAuthBtnClick, dataAuthBtnClick, changeSelect, dataColumnAuthBtnClick }, noShowArr) => {
  return {
    // checkbox: {
    //   title: '选择',
    //   key: 'checkbox',
    //   width: 50,
    //   render: (h, params) => {
    //     const { row, index } = params;
    //     return h('div', [
    //       h('Checkbox', {
    //         props: {
    //           value: row.selected
    //         },
    //         style: {
    //           textAlign: 'center'
    //         },
    //         on: {
    //           'on-change': (e) => {
    //             changeSelect(params, e);
    //           }
    //         }
    //       })
    //     ]);
    //   }
    // },
    index: {
      title: '序号',
      width: 50,
      key: 'menuIndex',
      align: 'right'
    },
    menuName: {
      title: '菜单名称',
      key: 'menuName',
      minWidth: 150,
      tree: true
    },
    id: {
      title: '菜单ID',
      key: 'id',
      minWidth: 350
    },
    menuCode: {
      title: '菜单编码',
      key: 'menuCode',
      minWidth: 80
    },
    menuType: {
      title: '菜单类型',
      key: 'menuType',
      width: 80,
      // renderText 过渡使用
      utableRender(row) {
        return row.menuType === 1 ? '菜单' : row.menuType === 2 ? '权限类型' : '登录';
      },
      render: (h, { row }) => {
        return h('p', {}, row.menuType == 1 ? '菜单' : row.menuType == 2 ? '权限类型' : '登录');
      }
    },
    menuSortNum: {
      title: '菜单顺序',
      key: 'menuSortNum',
      width: 80,
      align: 'right'
    },
    menuStatus: {
      title: '状态',
      key: 'menuStatus',
      width: 100,
      align: 'center',
      utableRender(row) {
        return row.menuStatus == 0 ? '禁用' : '启用';
      },
      render: (h, params) => {
        const { menuStatus } = params.row;
        return h('Tag', menuStatus == 0 ? { props: { color: 'volcano' } } : { props: { color: 'green' } }, menuStatus == 0 ? '禁用' : '启用');
      }
    }
    // action: {
    //   title: '操作',
    //   key: 'action',
    //   minWidth: 180,
    //   fixed: 'right',
    //   render: (h, { row }) => {
    //     const buttonArr = [];
    //     if (row.menuType != 3) {
    //       buttonArr.push(
    //         h('CustomButton', {
    //           props: { type: 'info', size: 'small', permissionCode: authType.menu.pageCompomentAuth },
    //           style: { margin: '4px' },
    //           on: {
    //             click: () => {
    //               pageAuthBtnClick(row);
    //             }
    //           }
    //         }, '控件权限'),
    //         h('CustomButton', {
    //           props: { type: 'info', size: 'small', permissionCode: authType.menu.dataRowAuth },
    //           style: { margin: '4px' },
    //           on: {
    //             click: () => {
    //               dataAuthBtnClick(row);
    //             }
    //           }
    //         }, '行权限'),
    //         h('CustomButton', {
    //           props: { type: 'info', size: 'small', permissionCode: authType.menu.dataColumnAuth },
    //           style: { margin: '4px' },
    //           on: {
    //             click: () => {
    //               dataColumnAuthBtnClick(row);
    //             }
    //           }
    //         }, '列权限')
    //       );
    //     }
    //     buttonArr.push(
    //       h('CustomButton', {
    //         props: { type: 'success', size: 'small', permissionCode: authType.menu.editMenuAuth },
    //         style: { margin: '4px' },
    //         on: {
    //           click: () => {
    //             editBtnClick(row);
    //           }
    //         }
    //       }, '编辑')
    //     );
    //     if (row.menuName != '菜单管理' && row.menuName != '91权限管理系统') {
    //       buttonArr.push(
    //
    //         h('CustomButton', {
    //           props: { type: 'error', size: 'small', permissionCode: authType.menu.deleteRowAuth },
    //           style: { margin: '4px' },
    //           on: {
    //             click: () => {
    //               deleteBtnClick(row);
    //             }
    //           }
    //         }, '删除')
    //       );
    //     }
    //     return h('div', { style: { 'text-align': 'left' } }, buttonArr);
    //   }
    // }
  };
};

const getColumns = (methods, noShowArr) => {
  const columnsMap = getColumnsMap(methods);
  const keyArr = Object.keys(columnsMap);
  const columns = [];
  keyArr.forEach(key => {
    if (!noShowArr || !noShowArr.includes(key)) {
      columns.push(columnsMap[key]);
    }
  });
  return columns;
};

const getPageCompColumnsMap = ({ deletePageCompBtnClick, editPageCompBtnClick }, noShowArr) => {
  return {
    index: {
      title: '序号',
      type: 'index',
      width: 60
    },
    componentName: {
      title: '页面控件名称',
      key: 'componentName',
      minWidth: 180
    },
    componentCode: {
      title: '页面控件编码',
      key: 'componentCode',
      minWidth: 180
    },
    componentStatus: {
      title: '状态',
      key: 'componentStatus',
      minWidth: 180,
      render: (h, { row }) => {
        return h('p', {}, row.componentStatus == 0 ? '禁用' : '隐藏');
      }
    },
    operation: {
      title: '操作',
      key: 'operation',
      minWidth: 180,
      render: (h, params) => {
        const buttonArr = [];
        buttonArr.push(

          h('Button', {
            props: { type: 'error', size: 'small' },
            style: { margin: '4px' },
            on: {
              click: () => {
                deletePageCompBtnClick(params.row);
              }
            }
          }, '删除'),
          h('Button', {
            props: { type: 'success', size: 'small' },
            style: { margin: '4px' },
            on: {
              click: () => {
                editPageCompBtnClick(params.row);
              }
            }
          }, '编辑')
        );
        return h('div', { style: { 'text-align': 'center' } }, buttonArr);
      }
    }
  };
};
const getPageCompColumns = (methods, noShowArr) => {
  const columnsMap = getPageCompColumnsMap(methods);
  const keyArr = Object.keys(columnsMap);
  const columns = [];
  keyArr.forEach(key => {
    if (!noShowArr || !noShowArr.includes(key)) {
      columns.push(columnsMap[key]);
    }
  });
  return columns;
};

// 数据列
const getDataColumnAuthColumns = (deleteDataColumnAuthBtnClick, editDataColumnAuthBtnClick) => {
  return [
    {
      title: '序号',
      type: 'index',
      width: 60
    },
    {
      title: '规则名称',
      key: 'ruleName',
      minWidth: 180
    },
    {
      title: '功能菜单id',
      key: 'funcMenuId',
      minWidth: 180
    },
    {
      title: '应用Id',
      key: 'appId',
      minWidth: 180
    },
    {
      title: '数据列规则id',
      key: 'id',
      minWidth: 180
    },
    {
      title: '用户填写的数据',
      key: 'ruleOrigJson',
      minWidth: 180
    },
    {
      title: '表名称',
      key: 'tableName',
      minWidth: 180
    },
    {
      title: '操作',
      key: 'operation',
      minWidth: 180,
      render: (h, params) => {
        const buttonArr = [];
        buttonArr.push(

          h('Button', {
            props: { type: 'error', size: 'small' },
            style: { margin: '4px' },
            on: {
              click: () => {
                deleteDataColumnAuthBtnClick(params.row);
              }
            }
          }, '删除'),
          h('Button', {
            props: { type: 'success', size: 'small' },
            style: { margin: '4px' },
            on: {
              click: () => {
                editDataColumnAuthBtnClick(params.row);
              }
            }
          }, '编辑')
        );
        return h('div', { style: { 'text-align': 'center' } }, buttonArr);
      }
    }
  ];
};
const getDataColumnAuthColumnsMap = ({ deleteDataColumnAuthBtnClick, editDataColumnAuthBtnClick }, noShowArr) => {
  return {
    index: {
      title: '序号',
      type: 'index',
      width: 60
    },
    ruleName: {
      title: '规则名称',
      key: 'ruleName',
      minWidth: 180
    },
    funcMenuId: {
      title: '功能菜单id',
      key: 'funcMenuId',
      minWidth: 180
    },
    appId: {
      title: '应用Id',
      key: 'appId',
      minWidth: 180
    },
    id: {
      title: '数据列规则id',
      key: 'id',
      minWidth: 180
    },
    ruleOrigJson: {
      title: '用户填写的数据',
      key: 'ruleOrigJson',
      minWidth: 180
    },
    tableName: {
      title: '表名称',
      key: 'tableName',
      minWidth: 180
    },
    operation: {
      title: '操作',
      key: 'operation',
      minWidth: 180,
      render: (h, params) => {
        const buttonArr = [];
        buttonArr.push(

          h('CustomButton', {
            props: { type: 'error', size: 'small', permissionCode: authType.menu.deleteColumnAuth },
            style: { margin: '4px' },
            on: {
              click: () => {
                deleteDataColumnAuthBtnClick(params.row);
              }
            }
          }, '删除'),
          h('CustomButton', {
            props: { type: 'success', size: 'small', permissionCode: authType.menu.editColumnAuth },
            style: { margin: '4px' },
            on: {
              click: () => {
                editDataColumnAuthBtnClick(params.row);
              }
            }
          }, '编辑')
        );
        return h('div', { style: { 'text-align': 'center' } }, buttonArr);
      }
    }
  };
};
const getDataRowAuthColumnsMap = ({ deleteDataRowAuthBtnClick, editDataRowAuthBtnClick }, noShowArr) => {
  return {

    index: {
      title: '序号',
      type: 'index',
      width: 60
    },
    ruleName: {
      title: '规则名称',
      key: 'ruleName',
      minWidth: 180
    },
    funcMenuId: {
      title: '功能菜单id',
      key: 'funcMenuId',
      minWidth: 180
    },
    appId: {
      title: '应用Id',
      key: 'appId',
      minWidth: 180
    },
    id: {
      title: '数据行规则id',
      key: 'id',
      minWidth: 180
    },
    ruleCondition: {
      title: '规则条件',
      key: 'ruleCondition',
      minWidth: 180
    },
    ruleField: {
      title: '规则字段',
      key: 'ruleField',
      minWidth: 180
    },
    ruleVal: {
      title: '规则值',
      key: 'ruleVal',
      minWidth: 180
    },
    tableName: {
      title: '表名称',
      key: 'tableName',
      minWidth: 180
    },
    operation: {
      title: '操作',
      key: 'operation',
      minWidth: 180,
      render: (h, params) => {
        const buttonArr = [];
        buttonArr.push(

          h('CustomButton', {
            props: { type: 'error', size: 'small', permissionCode: authType.menu.deleteRowAuth },
            style: { margin: '4px' },
            on: {
              click: () => {
                deleteDataRowAuthBtnClick(params.row);
              }
            }
          }, '删除'),
          h('Button', {
            props: { type: 'success', size: 'small', permissionCode: authType.menu.editRowAuth },
            style: { margin: '4px' },
            on: {
              click: () => {
                editDataRowAuthBtnClick(params.row);
              }
            }
          }, '编辑')
        );
        return h('div', { style: { 'text-align': 'center' } }, buttonArr);
      }
    }
  };
};
// 数据行
const getDataRowAuthColumns = (deleteDataRowAuthBtnClick, editDataRowAuthBtnClick) => {
  return [{
    title: '序号',
    type: 'index',
    width: 60
  },
  {
    title: '规则名称',
    key: 'ruleName',
    minWidth: 180
  },
  {
    title: '功能菜单id',
    key: 'funcMenuId',
    minWidth: 180
  },
  {
    title: '应用Id',
    key: 'appId',
    minWidth: 180
  },
  {
    title: '数据行规则id',
    key: 'id',
    minWidth: 180
  },
  {
    title: '规则条件',
    key: 'ruleCondition',
    minWidth: 180
  },
  {
    title: '规则字段',
    key: 'ruleField',
    minWidth: 180
  },
  {
    title: '规则值',
    key: 'ruleVal',
    minWidth: 180
  },
  {
    title: '表名称',
    key: 'tableName',
    minWidth: 180
  },
  {
    title: '操作',
    key: 'operation',
    minWidth: 180,
    fixed: 'left',
    render: (h, params) => {
      const buttonArr = [];
      buttonArr.push(

        h('Button', {
          props: { type: 'error', size: 'small' },
          style: { margin: '4px' },
          on: {
            click: () => {
              deleteDataRowAuthBtnClick(params.row);
            }
          }
        }, '删除'),
        h('Button', {
          props: { type: 'success', size: 'small' },
          style: { margin: '4px' },
          on: {
            click: () => {
              editDataRowAuthBtnClick(params.row);
            }
          }
        }, '编辑')
      );
      return h('div', { style: { 'text-align': 'center' } }, buttonArr);
    }
  }
  ];
};
export { getColumns, getPageCompColumns, getDataColumnAuthColumns, getDataRowAuthColumns, filterItems };
